// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pc4oCxZ2","title":"pNSXkpv0","description":"CzO25wgY","optionList":"blV0qkqj","option":"qgQnZP61","optionTitle":"DQ_aIRtt","optionDescription":"gHwY7V93"};